import { render, staticRenderFns } from "./myReportdetails.vue?vue&type=template&id=73a10191"
import script from "./myReportdetails.vue?vue&type=script&lang=js"
export * from "./myReportdetails.vue?vue&type=script&lang=js"
import style0 from "./myReportdetails.vue?vue&type=style&index=0&id=73a10191&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports